import React from 'react';
import { Modal, ModalHeader, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import ScreenForm from '../Forms/ScreenForm';

const AddEditScreenModal = ({
	dataScreen,
	isOpen,
	isEdit,
	handleToggleModal,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='lg'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Agregar'} Screen
			</ModalHeader>

			<ScreenForm
				dataScreen={dataScreen}
				isOpen={isOpen}
				isEdit={false}
				handleToggleModal={handleToggleModal}
			/>
		</Modal>
	);
};

export default AddEditScreenModal;
